import React, { useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { changeSelectedOrg, changeSelectedRole, getAllPermissions } from '../../app/store/action/PermissionAction';
import objectPath from 'object-path';
import Header from './header/Header';
import SubHeader from './sub-header/SubHeader';
import HeaderMobile from './header/HeaderMobile';
import AsideLeft from './aside/AsideLeft';
import Footer from './footer/Footer';
import ScrollTop from '../../app/partials/layout/ScrollTop';
import HTMLClassService from './HTMLClassService';
import LayoutConfig from './LayoutConfig';
import MenuConfig from './MenuConfig';
import LayoutInitializer from './LayoutInitializer';
import QuickPanel from '../../app/partials/layout/QuickPanel';
import KtContent from './KtContent';
import './assets/Base.scss';
import { getMenuBasedOnPermissions } from '../../utils';
import Cookie from 'js-cookie';
import setAuthToken from '../../utils/setAuthToken';

const htmlClassService = new HTMLClassService();

function Layout({ children, asideDisplay, subheaderDisplay, selfLayout, layoutConfig, contentContainerClasses }) {
  let location = useLocation().search;
  let params = new URLSearchParams(location);

  let menuParam; // arr
  if (params.get('menu')) {
    menuParam = params.get('menu').split(',');
  }

  const dispatch = useDispatch();

  const { permissions, selectedRole, selectedOrg } = useSelector(state => state.permission);
  let permissionLoadError = useSelector(state => state.permission.error);

  const menuConfig = permissions && getMenuBasedOnPermissions(permissions, MenuConfig, selectedRole, menuParam);

  // dispatch(getAllPermissions())

  const token = Cookie.get('edx-jwt-cookie');
  setAuthToken(token);

  useEffect(() => {
    /*!permissions && */ dispatch(getAllPermissions());
    // eslint-disable-next-line
  }, []);
  htmlClassService.setConfig(layoutConfig);
  // scroll to top after location changes
  // window.scrollTo(0, 0);

  const contentCssClasses = htmlClassService.classes.content.join(' ');

  // if (permissionLoadError) {
  // window.location.replace(`${process.env.REACT_APP_MARKETING_URL}/user/before-login`);
  // return (
  //   <p className="display-4 text-center my-5">در حال هدایت به صفحه ورود...</p>
  // );
  // } else {
  return selfLayout !== 'blank' && menuConfig ? (
    <LayoutInitializer menuConfig={menuConfig} layoutConfig={LayoutConfig} htmlClassService={htmlClassService}>
      {/* <!-- begin:: Header Mobile --> */}
      <HeaderMobile />
      {/* <!-- end:: Header Mobile --> */}

      <div className="kt-grid kt-grid--hor kt-grid--root">
        {/* <!-- begin::Body --> */}
        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
          {/* <!-- begin:: Aside Left --> */}
          {asideDisplay && (
            <>
              <AsideLeft />
            </>
          )}
          {/* <!-- end:: Aside Left --> */}
          <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
            {/* <!-- begin:: Header READY --> */}

            <Header />
            {/* <!-- end:: Header --> */}

            {/* <!-- begin:: Content --> */}
            <div
              id="kt_content"
              className={`kt-content ${contentCssClasses} kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor`}
            >
              {/* <!-- begin:: Content Head --> */}
              {subheaderDisplay && <SubHeader />}
              {/* <!-- end:: Content Head --> */}

              {/* <!-- begin:: Content Body --> */}
              {/* TODO: add class to animate  kt-grid--animateContent-finished */}
              <KtContent>{children}</KtContent>
              {/*<!-- end:: Content Body -->*/}
            </div>
            {/* <!-- end:: Content --> */}
            <Footer />
          </div>
        </div>
        {/* <!-- end:: Body --> */}
      </div>
      <QuickPanel />
      <ScrollTop />
    </LayoutInitializer>
  ) : (
    // BLANK LAYOUT
    <div className="kt-grid kt-grid--ver kt-grid--root">
      <KtContent>{children}</KtContent>
    </div>
  );
  // }
}

const mapStateToProps = ({ builder: { layoutConfig } }) => ({
  layoutConfig,
  selfLayout: objectPath.get(layoutConfig, 'self.layout'),
  asideDisplay: objectPath.get(layoutConfig, 'aside.self.display'),
  subheaderDisplay: objectPath.get(layoutConfig, 'subheader.display'),
  desktopHeaderDisplay: objectPath.get(layoutConfig, 'header.self.fixed.desktop'),
  contentContainerClasses: '',
});

export default connect(mapStateToProps)(Layout);
